import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './config/env' // Fail-fast on missing env vars at startup.
import { bootstrapAuth } from '@dfq/shared/auth'
import { ThemeProvider } from '@dfq/shared/components/ThemeProvider'
import { extendStoreReducer, store } from '@dfq/shared/stores/index'
import './index.css'
import App from './App.tsx'

// CON-VEH-001 — Console-side slice registration. Done BEFORE App mounts
// so the shared `<Provider store={store}>` inside <App /> already carries
// the `adminVehicles` reducer.
import { adminVehicleReducer } from './stores/adminVehicleSlice'
extendStoreReducer('adminVehicles', adminVehicleReducer)

// CON-PAYMENTS-004 — Disputes slice registration.
import { disputesReducer } from './stores/disputesSlice'
extendStoreReducer('disputes', disputesReducer)

// CON-ADMIN-002 — Admin dashboard slice registration.
import { adminDashboardReducer } from './stores/adminDashboardSlice'
extendStoreReducer('adminDashboard', adminDashboardReducer)

// CON-CAT-001 — Admin taxonomies slice registration.
import { adminTaxonomiesReducer } from './stores/adminTaxonomiesSlice'
extendStoreReducer('adminTaxonomies', adminTaxonomiesReducer)

// CON-SHIPPS-002 — Tracking import slice registration.
import { trackingImportReducer } from './stores/trackingImportSlice'
extendStoreReducer('trackingImport', trackingImportReducer)

// CON-CMS-001 — CMS pages slice registration.
import { cmsReducer } from './stores/cmsSlice'
extendStoreReducer('cms', cmsReducer)

// CON-CMS-003 — FAQ manager slice registration.
import { faqReducer } from './stores/faqSlice'
extendStoreReducer('faq', faqReducer)

// CON-CMS-004 — Gallery slice registration.
import { galleryReducer } from './stores/gallerySlice'
extendStoreReducer('gallery', galleryReducer)

// CON-CMS-005 — Testimonials slice registration.
import { testimonialsReducer } from './stores/testimonialsSlice'
extendStoreReducer('testimonials', testimonialsReducer)

// CON-PROMO-001 / CON-PROMO-002 — Coupons slice registration (list + editor).
import { couponsReducer } from './stores/couponsSlice'
extendStoreReducer('coupons', couponsReducer)

// CON-PROMO-005 / CON-PROMO-006 — Automatic promotions slice registration.
import { promotionsReducer } from './stores/promotionsSlice'
extendStoreReducer('promotions', promotionsReducer)

// CON-SEO-002 — URL redirects slice registration.
import { redirectsReducer } from './stores/redirectsSlice'
extendStoreReducer('redirects', redirectsReducer)

// CON-REPORT — Reports slice registration (sales, products, production views).
import { reportsReducer } from './stores/reportsSlice'
extendStoreReducer('reports', reportsReducer)

// CON-MAT2-005 — Admin product type config slice registration (create/edit form).
import { adminProductTypeConfigReducer } from './stores/adminProductTypeConfigSlice'
extendStoreReducer('adminProductTypeConfig', adminProductTypeConfigReducer)

// bootstrapAuth is async (SF-AUTH-PERSIST): awaiting it ensures that a
// cookie-based silent refresh settles before `RequireAuth` guards evaluate.
bootstrapAuth(store, { clientType: 'console' }).then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </StrictMode>,
  )
})
